var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer--mentions-and-language wrapper",attrs:{"id":"modal-call"}},[_c('mentions'),_vm._v(" "),_c('language')],1)}
var staticRenderFns = []

export { render, staticRenderFns }